import { CircleAlert } from "lucide-react";
import type { OrderValidationErrors } from "../types";

type OrderValidationSummaryProps = {
  errors: OrderValidationErrors;
};

export function OrderValidationSummary({ errors }: OrderValidationSummaryProps) {
  const messages = Object.values(errors).filter((message): message is string => Boolean(message));
  if (messages.length === 0) return null;

  return (
    <div className="order-validation-summary" role="alert" aria-live="assertive">
      <CircleAlert size={19} aria-hidden="true" />
      <div>
        <strong>Kontrollera beställningen</strong>
        <ul>
          {messages.map((message) => <li key={message}>{message}</li>)}
        </ul>
      </div>
    </div>
  );
}
